// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__jLAk9","inputWrap":"CustomTip_inputWrap__2VMHk"};